import React, { useEffect, useState, SyntheticEvent } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {Form, Button} from 'react-bootstrap';
import api from '../../services/api';
import Swal from 'sweetalert2';

const Details = (props) => {
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [Email, setEmail] = useState('');
    const [Role, setRole] = useState('');
    const [Enabled, setEnabled] = useState(true);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("member/" + id )
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setFirstName(result.first_name);
                            setLastName(result.last_name);
                            setEmail(result.email);
                            setRole(result.role);
                            setEnabled(result.is_active);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        //Swal.fire({
                        //    title: 'Erreur!',
                        //    text: "Une erreur s'est produite",
                        //    icon: 'error',
                        //    confirmButtonText: 'OK'
                        //});
                        setLoadingData(false);
                    });
            } catch (err) {
                //Swal.fire({
                //    title: 'Erreur!',
                //    text: "Une erreur s'est produite",
                //    icon: 'error',
                //    confirmButtonText: 'OK'
                //});
                setLoadingData(false);
            }
        }else{
            return history.push('/manage/members');
        }
    }

    useEffect(() => {
        getById();
        var selector = document.getElementById('title-section-id');
        if(selector != undefined)
            selector.textContent = "User details";
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>First Name: </label>
                            <p className="card-text">{FirstName}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Last Name: </label>
                            <p className="card-text">{LastName}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Email: </label>
                            <p className="card-text">{Email}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Role: </label>
                            <p className="card-text">{Role}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Is Active: </label>
                            <p className="card-text">{Enabled ? "True" : "False"}</p>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <NavLink className="btn btn-secondary" to="/manage/members"><i className="fa fa-chevron-left"></i> Back</NavLink>
                </div>
            </div>
        </>
    );
};

export default Details;
